import { getZoneByIdRequest } from "../../data/zoneApi";

function getPayloadData(response) {
  if (response?.data?.data) {
    return response.data.data;
  }

  if (response?.data) {
    return response.data;
  }

  return response;
}

export async function getZoneByIdUseCase(id) {
  return getPayloadData(await getZoneByIdRequest(id));
}
